import { render, staticRenderFns } from "./AdvisorArticle.vue?vue&type=template&id=bfb4b146&scoped=true"
import script from "./AdvisorArticle.vue?vue&type=script&lang=js"
export * from "./AdvisorArticle.vue?vue&type=script&lang=js"
import style0 from "./AdvisorArticle.vue?vue&type=style&index=0&id=bfb4b146&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb4b146",
  null
  
)

export default component.exports